import { render, staticRenderFns } from "./TiersHistory.vue?vue&type=template&id=7fefbcb8&"
import script from "./TiersHistory.vue?vue&type=script&lang=js&"
export * from "./TiersHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports